import { countMessagesReceivedByQuarterHourOfWeek } from '../queries/countMessagesReceivedByQuarterHourOfWeek'

export const messagesReceivedByQuarterHourOfWeekGauge = {
  id: 'messagesReceivedByQuarterHourOfWeekGauge',
  queries: [countMessagesReceivedByQuarterHourOfWeek],
  title: 'Busiest Hours of The Day',
}
